module.exports = __webpack_public_path__ + "static/media/137-1370051_avatar-generic-avatar-hd-png-download.27010980.png";